
export interface PatentDescService {
    /**
     * 获取专利描述
     */
    getPatentDesc(payload: {patentId: string, lang: string}): Promise<string>;
}

export const PatentDescService = Symbol.for('PatentDescService');
